import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { Button } from '@components/button'

import { ReactComponent as Logo } from './assets/img/logo.svg'

import { config } from '@shared/config'
import { Popup } from '@shared/layouts/popup'
import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import styles from './error-core.module.css'

interface ErrorCoreProps extends React.ComponentPropsWithoutRef<'div'> {
  error: unknown
  info?: {
    componentStack: string
  }
  handleBackClick?: () => void
}

export const ErrorCore = ({
  className,
  error,
  info,
  handleBackClick
}: ErrorCoreProps) => {
  const { t } = useTranslation('error')
  const navigate = useNavigate()
  const handleClick = async () => {
    await navigate({ to: '/', replace: true })
  }
  const [isOpen, setOpened] = useState<boolean>(true)
  const handleCloseClick = async () => {
    setOpened(false)
    handleBackClick ? await handleBackClick() : await handleClick()
  }

  console.log(error, info)

  return (
    <Popup isOpened={isOpen} onClose={handleCloseClick}>
      <div className={cn(styles.container, className)}>
        <Logo className={styles.icon} />
        <h1 className={styles.title}>{t('something-wrong')}</h1>
        <span className={styles.description}>{t('try-later')}</span>
        <Button className={styles.btn} sizeType="lg" onClick={handleClick}>
          {t('back-home')}
        </Button>
        <div className={styles.support}>
          <span className={styles.supportText}>{t('support-text')}</span>
          <a
            href={config.getTgBotSupportUrl()}
            target="_blank"
            rel="noreferrer"
            className={styles.supportLink}
          >
            <span>{t('support-link')}</span>
          </a>
        </div>
      </div>
    </Popup>
  )
}
